import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import AuthLayout from '../layouts/AuthLayout'
import AppLayout from '../layouts/AppLayout'
import LoginPage from '../pages/LoginPage'
import LogoutPage from '../pages/LogoutPage'
import DashboardPage from '../pages/DashboardPage'
import ExceptionPage from '../pages/ExeptionPage'
import TransferHistoryPage from '../pages/TransferHistoryPage'
import TransferDetailPage from '../pages/TransferDetailPage'
import CoursePaymentsPage from '../pages/CoursePaymentsPage'

const Routes = (): JSX.Element => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/login" />
        </Route>
        <Route path="/login" exact>
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        </Route>
        <Route path="/logout" exact>
          <LogoutPage />
        </Route>
        <Route path="/not-found">
          <ExceptionPage code={404} />
        </Route>
        <Route path={['/dashboard', '/transfer-history', '/course-payments']}>
          <AppLayout>
            <Route exact path="/dashboard">
              <DashboardPage />
            </Route>
            <Route exact path="/transfer-history">
              <TransferHistoryPage />
            </Route>
            <Route exact path="/transfer-history/:transferId">
              <TransferDetailPage />
            </Route>
            <Route path="/course-payments">
              <CoursePaymentsPage />
            </Route>
          </AppLayout>
        </Route>
        <Route path="*">
          <Redirect to="/not-found" />
        </Route>
      </Switch>
    </Router>
  )
}

export default Routes
